import i18n from 'i18next'

// Translate a message key against the app's i18n instance.
//
// Uses i18n.t (the instance method), NOT the useTranslation() hook: a "translate a string"
// helper must be callable anywhere — render, event handlers, mutation onSuccess/onError,
// async utils. useTranslation() is a React hook and only runs during render; calling it in a
// callback throws "Invalid hook call" (React error #321). The app is single-language (pt-BR),
// so the hook's only extra power (re-render on language change) is moot — i18n.t loses nothing.
export const trans = (text: string, options?: Record<string, string | number>): string => {
  return i18n.t(text, options)
}

export const changeSupportedLanguage = (supportedLanguage: string): void => {
  // 'en-US' | 'pt-BR' | 'es-ES'
  localStorage.setItem('language', supportedLanguage)
  i18n.changeLanguage(supportedLanguage)
}
